export const CMP_UI_SUPPRESSED_CLASS = 'cmp-ui-suppressed'

export const CMP_UI_SUPPRESSED_CSS = `html.${CMP_UI_SUPPRESSED_CLASS} #cmpbox,
html.${CMP_UI_SUPPRESSED_CLASS} #cmpbox2,
html.${CMP_UI_SUPPRESSED_CLASS} #cmpwrapper,
html.${CMP_UI_SUPPRESSED_CLASS} #cmppermanent,
html.${CMP_UI_SUPPRESSED_CLASS} #cmpwelcomebg,
html.${CMP_UI_SUPPRESSED_CLASS} iframe[src*="consentmanager.net"]{display:none!important;visibility:hidden!important;pointer-events:none!important}`

const CMP_UI_IDS = ['cmpbox', 'cmpbox2', 'cmpwrapper', 'cmppermanent', 'cmpwelcomebg'] as const

type CmpNode = {
  remove: () => void
}

/** Raíz consultable sin depender de `lib.dom` (shared/server). */
export type ConsentManagerQueryRoot = {
  querySelector: (selector: string) => CmpNode | null
  querySelectorAll: (selector: string) => ArrayLike<CmpNode>
}

type ClassListLike = {
  add: (token: string) => void
  remove: (token: string) => void
  contains: (token: string) => boolean
}

type CmpApi = (
  command: string,
  parameter?: unknown,
  callback?: unknown,
  async?: boolean
) => unknown

type ConsentStatus = {
  consentExists?: boolean
}

type ConsentManagerGlobal = {
  document?: ConsentManagerQueryRoot & {
    documentElement?: { classList: ClassListLike }
  }
  __cmp?: CmpApi
}

function consentManagerGlobal(): ConsentManagerGlobal {
  return globalThis as ConsentManagerGlobal
}

function defaultQueryRoot(): ConsentManagerQueryRoot | undefined {
  return consentManagerGlobal().document
}

function htmlClassList(): ClassListLike | undefined {
  return consentManagerGlobal().document?.documentElement?.classList
}

function isConsentStatus(value: unknown): value is ConsentStatus {
  return typeof value === 'object' && value !== null
}

export function hasConsentManagerUi(root?: ConsentManagerQueryRoot): boolean {
  const target = root ?? defaultQueryRoot()
  if (!target) return false
  if (CMP_UI_IDS.some((id) => target.querySelector(`#${id}`))) {
    return true
  }
  return target.querySelector('iframe[src*="consentmanager.net"]') !== null
}

/** Oculta el banner/botón sin destruir el DOM, para poder restaurarlo en SPA. */
export function hideConsentManagerUi(): void {
  consentManagerGlobal().__cmp?.('close')
  htmlClassList()?.add(CMP_UI_SUPPRESSED_CLASS)
}

/** Tras salir de checkout/zona de usuario: el botón vuelve; el muro solo si no hay consentimiento. */
export function restoreConsentManagerUi(): void {
  htmlClassList()?.remove(CMP_UI_SUPPRESSED_CLASS)

  const cmp = consentManagerGlobal().__cmp
  if (!cmp) return

  const status = cmp('consentStatus', null, null, false)
  if (isConsentStatus(status) && status.consentExists === false) {
    cmp('showScreen')
  }
}
